import type { auditReports } from '@mi-front/api-clients';
import { Box, TextField } from '@mui/material';
import { useIntl } from 'react-intl';

interface BooleanColumnConfigEditorProps {
  config: auditReports.BooleanColumnConfigDto;
  onTypeChange: (config: auditReports.BooleanColumnConfigDto) => void;
}

export function BooleanColumnConfigEditor({
  config,
  onTypeChange,
}: BooleanColumnConfigEditorProps) {
  const { $t } = useIntl();

  const handleTrueLabelChange = (value: string) => {
    onTypeChange({
      ...config,
      trueLabel: value || null,
    });
  };

  const handleFalseLabelChange = (value: string) => {
    onTypeChange({
      ...config,
      falseLabel: value || null,
    });
  };

  return (
    <Box marginTop={2} display="flex" flexDirection="column" gap={2}>
      <TextField
        fullWidth
        size="small"
        label={$t({
          id: 'audit.reportDefinitionEditor.columnType.boolean.trueLabel',
          defaultMessage: 'Etiqueta para verdadero',
        })}
        value={config.trueLabel || ''}
        onChange={(e) => handleTrueLabelChange(e.target.value)}
      />
      <TextField
        fullWidth
        size="small"
        label={$t({
          id: 'audit.reportDefinitionEditor.columnType.boolean.falseLabel',
          defaultMessage: 'Etiqueta para falso',
        })}
        value={config.falseLabel || ''}
        onChange={(e) => handleFalseLabelChange(e.target.value)}
      />
    </Box>
  );
}
